<template>
  <div class="table-container" :style="{'background-image':`url('${$store.getters.systemConfig.loginBackgroundImgUrl}')`}">
    <el-row style="height:60px;background: rgba(8, 8, 8, 0.4);">
      <el-col :span="24" style="height: 60px">
        <router-link target="_blank" to="/NotariaIndex">
          <img :src="$store.getters.systemConfig.logoLightUrl"  alt="公证系统"
               style="margin-left: 30px;margin-top:10px;float: left;height: 40px;cursor: pointer">
        </router-link>

      </el-col>
    </el-row>
    <el-row class="table-content">
      <el-row style="border-bottom: 1px solid #EEEEEE;margin: 0 -30px;padding: 0 30px; line-height: 60px;height: 60px;">
        <el-col :span="12">
          <div>
            <span
              style="display: inline-block;width: 5px;height: 15px;background: #1454EC;vertical-align: middle;margin-right: 5px;"></span>
            <span style="width:80px;height:24px;font-size:16px;font-weight:500;line-height:24px;color:#000;">区块链查询</span>
          </div>
        </el-col>
        <el-col style="text-align: right" :span="12" class="search">
          <span style="font-size: 14px;">备案号:</span>
          <el-input v-model="preservationId" style="height: 30px;">
            <el-button slot="append" @click="getChainDetail(preservationId)"
                       style="background:rgba(20,84,236,1);border-radius:0px 1px 1px 0px;height: 40px;border: 0;font-size:12px;color: #fff;">
              查询
            </el-button>
          </el-input>
        </el-col>
      </el-row>
      <el-table :data="chainDataList" :stripe="true" max-height="600px">
        <el-table-column label="备案号" prop="preservationId">
          <template v-slot="scope">
            {{scope.row.preservationId|leftPad(10)}}
          </template>
        </el-table-column>
        <el-table-column label="保全主体" prop="entityName"></el-table-column>
        <el-table-column label="保全来源" prop="sourceName"></el-table-column>
        <el-table-column label="保全时间" prop="preservationTime">
          <template slot-scope="scope">
            {{scope.row.preservationTime | formatDateTime}}
          </template>
        </el-table-column>
        <el-table-column label="详情">
          <template slot-scope="scope">
            <el-button type="text" size="small" @click="getChainDetail(scope.row.preservationId)" style="color: #1454EC; font-size: 14px">
              查看
            </el-button>
          </template>
        </el-table-column>
      </el-table>

      <router-link :to="{path: 'login'}">
        <el-button style="float: right;margin: 50px 0">返回</el-button>
      </router-link>


    </el-row>
    <el-dialog :visible.sync="visible" width="40%" :custom-class="'chainDetail'" :key="chainDetail.preservationId">
      <el-row :gutter="40">
        <el-col :span="8"><label>保全备案号:</label></el-col>
        <el-col :span="12">{{chainDetail.preservationId|leftPad(10)}}</el-col>
      </el-row>
      <el-row :gutter="40">
        <el-col :span="8"><label>操作用户证件:</label></el-col>
        <el-col :span="12">{{chainDetail.operatorEntityId}}</el-col>
      </el-row>
      <el-row :gutter="40">
        <el-col :span="8"><label>操作用户名称:</label></el-col>
        <el-col :span="12">{{chainDetail.operatorEntityName}}</el-col>
      </el-row>
      <el-row :gutter="40">
        <el-col :span="8"><label>保全主体证件:</label></el-col>
        <el-col :span="12">{{chainDetail.entityId}}</el-col>
      </el-row>
      <el-row :gutter="40">
        <el-col :span="8"><label>保全主体名称:</label></el-col>
        <el-col :span="12">{{chainDetail.entityName}}</el-col>
      </el-row>

      <el-row :gutter="40">
        <el-col :span="8"><label>保全时间戳:</label></el-col>
        <el-col :span="12">{{chainDetail.preservationTime|formatDateTime}}</el-col>
      </el-row>
      <el-row :gutter="40">
        <el-col :span="8"><label>保全文件Hash:</label></el-col>
        <el-col :span="12">{{chainDetail.sha512Hash}}</el-col>
      </el-row>
      <el-row :gutter="40">
        <el-col :span="8"><label>保全链交易Hash:</label></el-col>
        <el-col :span="12">{{chainDetail.ebqChainTransHash}}</el-col>
      </el-row>
    </el-dialog>
    <index-footer style="position:fixed;bottom: 0"></index-footer>

  </div>
</template>

<script>
  import {username, password} from '@/utils/validate';
  import httpServer from '../http/http-server';
  import ElButton from '../../node_modules/element-ui/packages/button/src/button.vue';
  import IndexFooter from '../components/indexFooter'



  export default {
    components: {ElButton,IndexFooter},
    name: 'Chain',
    data() {
      return {
        loading: false,
        chainDataList: [],
        preservationId: null,
        visible: false,
        chainDetail: {},
        dialogId: {},
      };
    },
    created: function() {
      this.getChainList();
    },
    methods: {
      getChainList() {
        var _this = this;
        httpServer.chainList().then(resp => {
          if (resp.success) {
            _this.chainDataList = resp.data;
          } else {
            _this.$message({message: resp.message, type: 'error'});
          }
        });
      },
      getChainDetail(preservationId) {
        httpServer.chainDetail({preseId: preservationId}).then(resp => {
          if (resp.success) {
            this.chainDetail = resp.data;
            this.visible = true;
            this.dialogId = Math.random();
          } else {
            this.$message({message: '暂不支持区块链查询，请到易保全官网查询', type: 'error'});
          }
        });
      },
    },
  };
</script>

<style scoped lang="less">
  @bg: #fff;
  @dark_gray: #889aa4;
  @light_gray: grey;
  @black: #000;



  .table-container {
    min-width: 1200px;
    height: 100%;
    min-height: 768px;
    /*background: url("../../static/img/loginbg.png") no-repeat;*/
    background-size: cover;

    input {
      border: 1px solid rgba(102, 102, 102, 1) !important;
      border-radius: 4px;
    }

    .userSide {
      width: 100px;
      height: 40px;
      font-size: 24px;
      font-weight: 200;
      line-height: 60px;
      color: rgba(255, 255, 255, 0.65);
      margin-left: 20px
    }

    .table-content {
      width: 1200px;
      height: calc(100% - 100px);
      margin: 0 auto;
      padding: 0 30px;
      margin-top: 24px;
      background: rgb(255, 255, 255);
      border-radius: 2px;
    }
  }

  .chainDetail .el-row {
    padding: 10px;
    font-size: 16px;
  }

  .el-input-group {
    width: 260px;
    vertical-align: middle;
  }
</style>
<style>
/* 滚动条的宽度 */
html:has(.table-container)::-webkit-scrollbar {
  //width: 10px;
  //height: 10px;
  width: 0;
}
.el-table__body-wrapper::-webkit-scrollbar {
  //width: 10px;
  //height: 10px;
  width: 0;
}
</style>



// WEBPACK FOOTER //
// src/pages/Chain.vue